import axios from 'axios';
import config from '../config';

const KEY = 'pendingSessionLogouts';
let pendingRequest: Promise<void> | null = null;

function readPending(): string[] {
    try {
        const parsed: unknown = JSON.parse(localStorage.getItem(KEY) ?? '[]');
        return Array.isArray(parsed) ? parsed.filter((value): value is string => typeof value === 'string') : [];
    } catch { return []; }
}

export function queueSessionLogout(logoutToken?: string): void {
    if (!logoutToken) return;
    const pending = readPending();
    if (!pending.includes(logoutToken)) localStorage.setItem(KEY, JSON.stringify([...pending, logoutToken]));
}

export function flushSessionLogouts(): Promise<void> {
    pendingRequest ??= (async () => {
        for (const logoutToken of readPending()) {
            try {
                await axios.post(`${config.managementBaseUrl}/users/logout`, { logoutToken }, { timeout: 5000, withCredentials: false });
                localStorage.setItem(KEY, JSON.stringify(readPending().filter(token => token !== logoutToken)));
            } catch { return; }
        }
    })().finally(() => { pendingRequest = null; });
    return pendingRequest;
}